import {cx} from "emotion";
import * as React from "react";

import {cs}              from "@Common/react/chain-services";
import {Static2}         from "@Common/react/static-2";
import {DomSizeObserver} from "@Common/ui-components/dom-size-observer";

export const CanvasDesktop = ({className, next}) => cs(
    ["size", (_, next) => DomSizeObserver({
        next,
    })],
    ["ref", (_, next) => Static2({next})],
    ({size, ref}) => (
        <div className={cx("canvas-desktop-0wo canvas-desktop", className)} ref={(d) => {size.ref?.(d); ref.set(d)}}>
            {next({
                size: size.value,
                getBoundingClientRect: () => ref.get().getBoundingClientRect(),
            })}
        </div>
    )
);
